import { ImageLoader } from 'next/image';

// Passthrough loader: serve images exactly as addressed (bundled assets via
// assetPrefix, driver photos via their backend URL). There is no Next image
// optimizer in the static R2+Worker deployment, and the k8s path never
// depended on it for correctness.
const imageLoader: ImageLoader = ({ src }) => src;

export default imageLoader;
